import throttle from 'lodash.throttle';

const toTopBtn = document.querySelector('.to_top');
const triggerHeight = window.innerHeight * 2.13;

/**
 * Здесь обрабатывается только само появление scroll_top.
 * Логика прокрутки лежит в ScrollToAnchor.js
 */
const init = () => {
    window.addEventListener(
        'scroll',
        throttle(() => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

            if (scrollTop >= triggerHeight) {
                toTopBtn.classList.add('to_top--visible');
            } else {
                toTopBtn.classList.remove('to_top--visible');
            }
        }, 100)
    );
};

export default init();
